/* ==========================================================================
   SERRAMO SPC — JavaScript
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- BEDARFSRECHNER (Länge × Breite + Direkt m²) ---- */
  const calcOutput = document.getElementById('serramo-calc-output');
  const calcLength = document.getElementById('calc-length');
  const calcWidth = document.getElementById('calc-width');
  const calcSqmInput = document.getElementById('calc-sqm-input');
  const calcSqmResult = document.getElementById('calc-sqm-result');
  const qtyInput = document.getElementById('qty');
  const modeBtns = document.querySelectorAll('.calc-box__mode-btn');
  const fieldsGroups = document.querySelectorAll('.calc-box__fields');

  if (calcOutput) {
    const sqmPerPack = parseFloat(calcOutput.dataset.sqmPerPack) || 2.21;
    const wasteFactor = parseFloat(calcOutput.dataset.waste) || 1.06;
    let activeMode = 'dimensions';

    function getSqm() {
      if (activeMode === 'dimensions') {
        var l = parseFloat(calcLength ? calcLength.value : 0) || 0;
        var w = parseFloat(calcWidth ? calcWidth.value : 0) || 0;
        return l * w;
      } else {
        return parseFloat(calcSqmInput ? calcSqmInput.value : 0) || 0;
      }
    }

    function calculate() {
      var sqm = getSqm();

      if (calcSqmResult && activeMode === 'dimensions') {
        if (sqm > 0) {
          calcSqmResult.textContent = '= ' + sqm.toFixed(2).replace('.', ',') + ' m\u00B2';
        } else {
          calcSqmResult.textContent = '';
        }
      }

      if (sqm <= 0) {
        calcOutput.textContent = '';
        return;
      }

      var withWaste = sqm * wasteFactor;
      var packages = Math.ceil(withWaste / sqmPerPack);
      var totalSqm = (packages * sqmPerPack).toFixed(2).replace('.', ',');
      calcOutput.textContent = '= ' + packages + ' Pakete \u00B7 ' + totalSqm + ' m\u00B2 (6% Verschnitt inkl.)';

      if (qtyInput) {
        qtyInput.value = packages;
      }
    }

    modeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        activeMode = btn.dataset.mode;
        modeBtns.forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        fieldsGroups.forEach(function(f) { f.classList.remove('is-active'); });
        var target = activeMode === 'dimensions' ? document.getElementById('calc-dimensions') : document.getElementById('calc-sqm-direct');
        if (target) target.classList.add('is-active');
        calculate();
      });
    });

    if (calcLength) calcLength.addEventListener('input', calculate);
    if (calcWidth) calcWidth.addEventListener('input', calculate);
    if (calcSqmInput) calcSqmInput.addEventListener('input', calculate);

    calculate();
  }

  /* ---- SHRINKING HEADER ---- */
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        siteHeader.classList.add('is-shrunk');
      } else {
        siteHeader.classList.remove('is-shrunk');
      }
    }, { passive: true });
  }

  /* ---- MOBILE NAV TOGGLE ---- */
  const hamburger = document.querySelector('.site-header__hamburger');
  const nav = document.querySelector('.site-header__nav');

  if (hamburger && nav) {
    hamburger.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      hamburger.classList.toggle('is-active');
    });
  }

  /* ---- PRODUCT GALLERY (no longer uses thumbnail switcher) ---- */

  /* ---- SMOOTH SCROLL FOR ANCHOR LINKS ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- ADD TO CART AJAX ---- */
  const addToCartForms = document.querySelectorAll('.product-form');

  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;

      submitBtn.textContent = 'Wird hinzugefügt...';
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        submitBtn.textContent = 'Hinzugefügt!';
        setTimeout(function () {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);

        // Update cart count
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var countEls = document.querySelectorAll('.site-header__cart-count');
            countEls.forEach(function (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
          });
      })
      .catch(function (err) {
        console.error('Cart error:', err);
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      });
    });
  });

});
